import { Space, Tag } from 'antd';
import React from 'react';

const ListScreenKeys = ({ documentData }) => {
  const record = documentData;

  const colorArray = ['blue', 'red', 'geekblue', 'green', 'volcano', 'orange', 'cyan', 'purple', 'blue', 'red', 'geekblue', 'green', 'volcano', 'orange', 'cyan', 'purple'];

  return [
    {
      label: 'Labels',
      value: record?.tags ? (
        <Space size={[0, 2]} wrap>
          {record?.tags?.map((tag, index) => (
            <Tag
              key={index}
              color={colorArray[index]}
              style={{
                fontSize: '11px',
                margin: '0 2px',
              }}
            >
              {tag}
            </Tag>
          ))}
        </Space>
      ) : '-',
    },
  ];
};

export default ListScreenKeys;
